import { Helmet } from 'react-helmet-async';
import React from 'react';
import ForgotPasswordFormContainer from '../containers/auth/ForgotPasswordFormContainer.jsx';

function ForgotPassword() {
  return (
    <div className="component-centered">
      <Helmet>
        <title>ChangeSync</title>
      </Helmet>
      <ForgotPasswordFormContainer />
    </div>
  );
}

export default ForgotPassword;
